import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Dialog         from '@material-ui/core/Dialog'
import DialogActions  from '@material-ui/core/DialogActions'
import DialogContent  from '@material-ui/core/DialogContent'
import DialogTitle    from '@material-ui/core/DialogTitle/DialogTitle'
import Grid           from '@material-ui/core/Grid/Grid'
import MenuItem       from '@material-ui/core/MenuItem/MenuItem'
import { withStyles } from '@material-ui/core/styles'

import { InjectedFormikProps, withFormik } from 'formik'

import { Contact }                                 from '../../api'
import { sectors }                                 from '../../project-utils/hardcoded'
import { FormikFormChunkProps }                    from '../../types'
import { stopNestedSubmissionBubbling }            from '../../utils'
import { AbstractedFormikTextField, ActionButton } from '../atoms'
import { genValueMapper, proxyFormikSubmission }   from './form-utils'
import { contactSchema, emptyContact }             from './schemas'
import { FormikSubmissionCallBack }                from './types'

/* TODO: is it fine for this to be hardcoded like this or should this be an api call? */

const AddContactChunk = (props: FormikFormChunkProps<Contact>) => (
  <Grid container spacing={16} direction={'column'}>
    <Grid item>
      <AbstractedFormikTextField
        {...props}
        autoFocus
        fullWidth
        identifier={'email'}
      />
    </Grid>
    <Grid item>
      <AbstractedFormikTextField
        {...props}
        fullWidth
        identifier={'name'}
      />
    </Grid>
    <Grid item>
      <AbstractedFormikTextField
        {...props}
        fullWidth
        identifier={'position'}
      />
    </Grid>
    <Grid item>
      <AbstractedFormikTextField
        fullWidth
        identifier={'company'}
        {...props}
      />
    </Grid>
    <Grid item>
      <AbstractedFormikTextField
        {...props}
        fullWidth
        identifier={'sector'}
        select
        InputLabelProps={{ shrink: true }}
      >
        {sectors.map(sector => (
          <MenuItem key={sector} value={sector}>
            <FormattedMessage id={`sectors.${sector}`} />
          </MenuItem>
        ))}
      </AbstractedFormikTextField>
    </Grid>
    <Grid item>
      <AbstractedFormikTextField
        fullWidth
        identifier={'phone'}
        {...props}
      />
    </Grid>
    <Grid item>
      <AbstractedFormikTextField
        fullWidth
        identifier={'mobile'}
        {...props}
      />
    </Grid>
  </Grid>
)

interface AddContactFormProps {
  isOpen: boolean
  onSubmit: FormikSubmissionCallBack<Contact>
  close: () => void
}

const Form = withStyles({
  paper: {
    width: '100%',
  },
})<InjectedFormikProps<AddContactFormProps, Contact>>(
  props => {
    const { handleSubmit, classes } = props

    const phrasing = {
      addNewContact: <FormattedMessage id={'generic.addNewContact'} />,
    }

    return (
      <Dialog
        onClose={props.close}
        open={props.isOpen}
        classes={{ paper: classes.paper }}
      >
        <form onSubmit={stopNestedSubmissionBubbling(handleSubmit)}>
          <DialogTitle>
            {phrasing.addNewContact}
          </DialogTitle>
          <DialogContent>
            <AddContactChunk {...props} />
          </DialogContent>
          <DialogActions>
            <ActionButton
              actionType={'submit'}
              variant={'raised'}
              color={'secondary'}
              type={'submit'}
            />
          </DialogActions>
        </form>
      </Dialog>
    )
  },
)

export default withFormik<AddContactFormProps, Contact>({
  mapPropsToValues: genValueMapper(emptyContact),
  validationSchema: contactSchema,
  handleSubmit:     proxyFormikSubmission,
})(Form)



// WEBPACK FOOTER //
// ./src/components/forms/ContactAddForm.tsx